import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type ContactDimension = { name: string, value: string }

export enum ContactStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED',
    ARCHIVED = 'ARCHIVED'
}

export type Contact = {
    id: string,
    firstName?: string,
    lastName?: string,
    email?: string,
    phone?: string,
    company?: string,
    position?: string,
    notes?: string,
    status?: ContactStatus,
    createdByUsername?: string,
    managedByUsername?: string,
    created?: string,
    updated?: string,
}


export interface IContactTableColumn extends ITableColumn {
    render?: (item: Contact) => ReactNode;
}
